import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cloneLayout } from "../../../core/actionCreators/lmsActionCreator";
import { MdClose } from "react-icons/md";
import toast from "react-hot-toast";
import "./CloneLayoutPopup.scss";

const CloneLayoutPopup = (props: any) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { layoutId, layoutName, layoutCode, device, componentCount, setCloneLayoutPopup } = props
    let { user } = useSelector((s: any) => s.authStore);

    const [isCloning, setIsCloning] = useState(false)

    const cloneClickHandler = () => {
        if (!layoutId) {
            toast.error("Something went wrong.")
            return
        }

        setIsCloning(true)
        dispatch(cloneLayout({ "layoutId": layoutId, "modifiedBy": user.id || -1 }, (r: any, summary: any) => {
            setIsCloning(false)
            if (r) {
                toast.error(r?.statusDescription || "Could not clone this layout.")
                return
            }

            toast.success(summary?.newLayoutName
                ? `Cloned as ${summary.newLayoutName} (${summary.newLayoutCode}).`
                : "Layout cloned successfully.")
            setCloneLayoutPopup(false)

            //Straight to the copy, the layout page reloads itself from the new id
            if (summary?.newLayoutId) {
                navigate(`/layout/${summary.newLayoutId}`)
            }
        }))
    }

    return (<>
        <div className="popup-container">
            <div className="overlay">
                <div className="popup-content popup-card clone-layout-popup">
                    <div className="popup-head flex items-start justify-between">
                        <div>
                            <h2>Clone Layout</h2>
                            <p>A full copy is created, the original is left untouched.</p>
                        </div>
                        <button onClick={() => setCloneLayoutPopup(false)} title="Close" className="popup-close flex items-center justify-center">
                            <MdClose size={18} />
                        </button>
                    </div>

                    <div className="popup-body">
                        <div className="clone-source">
                            <p className="clone-source-name">{layoutName}</p>
                            <p className="clone-source-meta">
                                {device} | {layoutCode}
                                {componentCount ? ` | ${componentCount} components` : ""}
                            </p>
                        </div>
                        <p className="clone-note">
                            Its components, elements and attributes are copied into a new layout with
                            its own layout code, and you are taken to the copy. Clone this layout?
                        </p>
                    </div>

                    <div className="popup-foot flex justify-end items-center">
                        <button onClick={() => setCloneLayoutPopup(false)} disabled={isCloning} className="bg-transparent font-semibold text-slate-800 py-2 px-6">
                            Cancel
                        </button>
                        <button onClick={cloneClickHandler} disabled={isCloning} className="bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 py-2 px-6">
                            {isCloning ? "Cloning..." : "Clone Layout"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default CloneLayoutPopup
